import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AuditEvent } from '../models/EventHistoryModels';

export const useEventHistory = () => {
  const { t } = useTranslation();

  const getEventTitle = useCallback(
    (event: AuditEvent): string => {
      switch (event) {
        case AuditEvent.TenantCreate:
          return t('Tenant created');
        case AuditEvent.TenantDelete:
          return t('Tenant deleted');
        case AuditEvent.TenantUpdate:
          return t('Tenant updated');
        case AuditEvent.WorkspaceUpdate:
          return t('Workspace updated');
        case AuditEvent.UserCreate:
          return t('User created');
        case AuditEvent.UserUpdate:
          return t('User updated');
        case AuditEvent.AdminUserUpdate:
          return t('Admin user changed');
        case AuditEvent.UserDelete:
          return t('User deleted');
        case AuditEvent.UserPasswordReset:
          return t('User password reset');
        case AuditEvent.UserOtpCodeSent:
          return t('Password reset OTP code sent');
        case AuditEvent.UserLocked:
          return t('User locked');
        case AuditEvent.UserLockWarning:
          return t('User lock warning email sent');
        case AuditEvent.UserLockExpired:
          return t('User lock expired');
        case AuditEvent.DomainCreate:
          return t('Domain added');
        case AuditEvent.DomainDelete:
          return t('Domain deleted');
        case AuditEvent.TaniumInstanceLinked:
          return t('Tanium Instance linked');
        case AuditEvent.TaniumInstanceUnlinked:
          return t('Tanium Instance unlinked');
        case AuditEvent.TaniumInstanceCreate:
          return t('Tanium Instance created');
        case AuditEvent.TaniumInstanceDelete:
          return t('Tanium Instance deleted');
        case AuditEvent.TaniumInstanceDeactivated:
          return t('Tanium Instance deactivated');
        case AuditEvent.TaniumInstanceReactivated:
          return t('Tanium Instance reactivated');
        case AuditEvent.TaniumInstanceRemoved:
          return t('Deleted Instance removed');
        case AuditEvent.IdpCreate:
          return t('Identity Provider created');
        case AuditEvent.IdpUpdate:
          return t('Identity Provider updated');
        case AuditEvent.IdpDelete:
          return t('Identity Provider deleted');
        case AuditEvent.GettingStartedEmailSent:
          return t('Getting Started Email Sent');
        case AuditEvent.LinkedInstanceEmailSent:
          return t('Linked Instance Email Sent');
        case AuditEvent.UnlinkedInstanceEmailSent:
          return t('Unlinked Instance Email Sent');
        case AuditEvent.IdpCertExpirationEmailSent:
          return t('Idp Certificate Expiration Email Sent');
        case AuditEvent.LicenseUpdatedEmailSent:
          return t('License Updated Email Sent');
        case AuditEvent.LicenseDeliveredInAMP:
          return t('License made available for download');
        case AuditEvent.InstanceLinkedInAMP:
          return t('Instance linked');
        case AuditEvent.OnPremInstanceOnboarded:
          return t('On-Premise instance onboarded');
        case AuditEvent.LicenseDownloadedFromAMP:
          return t('License downloaded');
        case AuditEvent.LicenseDeletedFromAMP:
          return t('License removed');
        case AuditEvent.LoginIdpError:
          return t('IDP Login Error');
        case AuditEvent.LoginAuthenticateError:
          return t('Authentication Error');
        case AuditEvent.CaseGrantGranted:
          return t('Case access granted');
        case AuditEvent.CaseGrantUpdated:
          return t('Case access updated');
        case AuditEvent.CaseGrantRevoked:
          return t('Case access revoked');
        default:
          return '';
      }
    },
    [t]
  );

  return { getEventTitle };
};
